<template>
    <div class="rank-container" :class="isSelect || selectSort ?'over-hidden':''">
        <div class="top-search">
            <div class="input-navigate-box" v-debounce="goCitySelect">
                <img src="../../assets/img/location.png" class="location-img" />
                <div id="cityBtn">{{currentCityName}}</div>
                <img src="../../assets/img/city-arrow.png" class="city-arrow" />
            </div>
            <div class="img-search" v-debounce="goSearch">
                <div class="input-navigate-box">
                    <img class="search-icon" src="../../assets/img/icon_search_default.png" />
                    <div class="HomeSearchBar" style="width:100%;">请输入选址目标商圈或小区</div>
                </div>
            </div>
        </div>
        <div class="select-container">
            <div class="area-box" @click="chooseArea">
                <label
                    class="area-title"
                    :class="searchName||isSelect ? 'selected':''"
                >{{searchName.length>4?searchName.slice(0,4)+'...':searchName || '筛选'}}</label>
                <img class="area-img" v-if="!isSelect" src="../../assets/img/down-arow.png" />
                <img class="area-img" v-if="isSelect" src="../../assets/img/blue_top.png" />
            </div>
            <div class="area-box" @click="openMore">
                <label
                    class="area-title"
                    :class="searchName1||isSelect1 ? 'selected':''"
                >{{searchName1 || '更多'}}</label>
                <img class="area-img" v-if="!isSelect1" src="../../assets/img/down-arow.png" />
                <img class="area-img" v-if="isSelect1" src="../../assets/img/blue_top.png" />
            </div>
            <div class="area-box" @click="selectSorting">
                <label
                    class="area-title"
                    :class="searchName2||isSelect2 ? 'selected':''"
                >{{searchName2 || '排序'}}</label>
                <img class="area-img" v-if="!isSelect2" src="../../assets/img/down-arow.png" />
                <img class="area-img" v-if="isSelect2" src="../../assets/img/blue_top.png" />
            </div>
            <div class="order-box" @click="returnMap">
                <img class="order-img" src="../../assets/img/map.png" />
            </div>
            <div class="filter-warp" v-if="isSelect">
                <div class="filter-container">
                    <div class="filter-condition city-box">
                        <div class="city-list filter-city">
                            <div
                                class="city-list-item city"
                                :class="searchType=='area' ? 'selected': ''"
                                @click.stop="selectArea('area')"
                            >位置</div>
                            <div
                                class="city-list-item city"
                                :class="searchType=='line' ? 'selected': ''"
                                @click.stop="selectArea('line')"
                            >地铁</div>
                        </div>
                        <!-- 第二级别 -->
                        <div class="city-list filter-district">
                            <div
                                v-for="(districtItem,districtIndex) in districtList"
                                :key="districtIndex"
                                class="city-list-item district"
                                :class="lineType===('line'+districtIndex) ? 'selected' : ''"
                                @click.stop="selectStanding('district',districtIndex,districtItem)"
                            >{{districtItem.name}}</div>
                        </div>
                        <div class="city-list filter-district">
                            <div
                                class="city-list-item district"
                                :class="standType===('stand9999') ? 'selected' : ''"
                                @click.stop="selectDistrict('area','9999')"
                                v-if="standingList.length>0"
                            >
                                不限
                                <img
                                    class="select-img"
                                    v-if="standType===('stand9999')"
                                    src="../../assets/img/rectangle.png"
                                />
                            </div>
                            <div
                                class="city-list-item district"
                                :class="standType===('stand'+areaIndex) ? 'selected' : ''"
                                v-for="(area,areaIndex) in standingList"
                                :key="areaIndex"
                                @click.stop="selectDistrict('area',areaIndex,area)"
                            >
                                <label>{{area.name}}</label>
                                <img
                                    class="select-img"
                                    v-if="standType===('stand'+areaIndex)"
                                    src="../../assets/img/rectangle.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-mask" v-if="isSelect" @click="hideSearch">
        </div>
        <div class="filter-mask" v-if="isSelect2 || selectSort" @click="hideMore">
            <div class="sorting-box" v-if="selectSort">
                <div
                    class="sort-item"
                    v-for="(item,index) in sortingList"
                    :key="index"
                    @click="checkedSort(index,'sort')"
                >
                    <label :class="item.checked? 'blue-color': ''">{{item.label}}</label>
                    <img class="sort-img" :src="item.src" v-if="item.checked" />
                </div>
            </div>
        </div>
        <div class="filter-mask" v-if="isSelect1 || selectSort1" @click="hideSort">
            <div class="sorting-box" v-if="selectSort1">
                <div
                    class="sort-item"
                    v-for="(item,index) in moreList"
                    :key="index"
                    @click="checkedSort(index,'more')"
                >
                    <label :class="item.checked? 'blue-color': ''">{{item.label}}</label>
                    <img class="sort-img" :src="item.src" v-if="item.checked" />
                </div>
            </div>
        </div>
        <van-pull-refresh v-model="isRefresh" :animation-duration="100" @refresh="onRefresh">
            <div v-if="villageList.length>0">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="暂无更多小区了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad"
                    class="village-content-wrapper"
                >
                    <div
                        class="village-content"
                        v-for="(item,index) in villageList"
                        :key="index"
                    >
                        <div class="content-header" @click.stop="goDetail(item)">
                            <div class="content-header-left">
                                <label class="title">{{item.communityName}}</label>
                                <div class="grade-box">
                                    <img class="header-img" src="../../assets/img/score.png" />
                                    <label class="grade-num">{{item.score}}分</label>
                                </div>
                            </div>
                        </div>
                        <div class="content-info" @click.stop="goDetail(item)">
                            <div class="rank-item">
                                <div class="rank-title">挂牌量</div>
                                <div class="rank-number" v-if="item.houseNum">{{item.houseNum}}</div>
                                <div class="rank-number" v-else>-</div>
                            </div>
                            <div class="rank-item">
                                <div class="rank-title">月租金</div>
                                <div class="rank-number" v-if="item.unitRentPrice">{{item.unitRentPrice}}元/㎡</div>
                                <div class="rank-number" v-else>-</div>
                            </div>
                            <div class="rank-item">
                                <div class="rank-title">建成时间</div>
                                <div class="rank-number" v-if="item.completeTime">{{item.completeTime}}</div>
                                <div class="rank-number" v-else>-</div>
                            </div>
                            <div class="rank-item">
                                <div class="rank-title">户数</div>
                                <div class="rank-number" v-if="item.houseCount">{{item.houseCount}}</div>
                                <div class="rank-number" v-else>-</div>
                            </div>
                        </div>
                        <div class="operation-box">
                            <div class="business-circle">
                              <img class="business-circle-img" src="../../assets/img/location1.png" />
                              <span class="business-circle-dec">{{item.area}}-{{item.zone}}</span>
                            </div>
                            <div class="operation">
                                <van-button plain hairline class="operation-btn" :class="contrastArr.indexOf(item.communityId)!=-1?'finished':'contrast'" :disabled="contrastArr.indexOf(item.communityId)!=-1?true:false" @click="plusContrast(index,item)">{{contrastArr.indexOf(item.communityId)!=-1?'已对比':'+ 对比'}}</van-button>
                                <van-button plain hairline class="operation-btn" :class="attentionArr.indexOf(index)!=-1||item.isCare==1?'finished':'attention'" :disabled="attentionArr.indexOf(index)!=-1||item.isCare==1?true:false" @click="plusAttention(index,item)">{{attentionArr.indexOf(index)!=-1||item.isCare==1?'已关注':'+ 关注'}}</van-button>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <div v-else>
                <div class="nodata">
                    <label class="info">没有搜到相关小区</label>
                </div>
            </div>
            <div class="footer" v-if="allLoaded && villageList.length>0">
                <label>暂无更多小区了</label>
            </div>
        </van-pull-refresh>
        <div class="contrast-box" @click.stop="goContrast">
            <img class="contrast-img" src="../../assets/img/contrast.png" />
            <span class="contrast-dec">对比</span>
            <div class="contrast-marker-box">
              <span class="contrast-marker">{{contrastCount}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { List, PullRefresh } from "vant";
import { Dialog,Toast,Button } from "vant";
import BScroll from 'better-scroll'
let timestampStart,timestampEnd;
export default {
  name: "rank",
  components: {
    "van-list": List,
    "van-pull-refresh": PullRefresh,
    "van-button":Button
  },
  data() {
    return {
      districtList: [],
      standingList: [],
      sortingList: [
        {
          label: "评分降序",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        },
        {
          label: "评分升序",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        },
        {
          label: "租金降序",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        },
        {
          label: "租金升序",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        }
      ],
      moreList: [
        {
          label: "我的关注",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        },
        {
          label: "浏览历史",
          src: require("../../assets/img/rectangle.png"),
          checked: false
        }
      ],
      villageList: [],
      loadMore: false,
      noData: false,
      isSelect: false,
      isSelect1: false,
      isSelect2: false,
      pageNum: 1,
      pageSize: 10,
      allLoaded: false,
      loading: false,
      finished: false,
      isRefresh: false,
      error: false,
      selectSort: false,
      selectSort1: false,
      standType: "",
      lineType: "",
      searchType: "area",
      sorting: "DESC",
      cityId: "",
      districtId: "",
      zoneId: "",
      searchIndex: "",
      areaIndex: "",
      subwayLineId: "",
      subwaySiteId: "",
      searchName: "",
      searchName1: "",
      searchName2: "",
      firstInfo: {},
      contrastCount:0,
      contrastArr:[],
      attentionArr:[],
      currentCityName:'北京',
      allInfo:{},
      moreTab:"",
      sortItem:"",
      userId: ''
    };
  },
  directives: {
    debounce: {
      inserted: function(el, binding) {
        let timer;
        el.addEventListener("click", () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 500);
        });
      }
    }
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '小区列表'
    });
    let options = this.$route.query;
    this.cityId = options.cityId;
    if (options.userId) {
      this.userId = options.userId;
      localStorage.setItem("userId", options.userId);
    }
    let cellContrastArr =JSON.parse(localStorage.getItem('cellContrastArr'));
    if (cellContrastArr) {
      this.contrastCount = cellContrastArr.length;
      this.contrastArr = cellContrastArr;
    }
    let cityData = JSON.parse(localStorage.getItem("city"));
    if (cityData) {
      this.currentCityName = cityData.item.name;
      localStorage.setItem('selectCityIndex',JSON.stringify(cityData.currentIndex))
      if (this.cityId!=cityData.item.value) {
        this.cityId = cityData.item.value;
      }
    }else{
      this.currentCityName = JSON.parse(localStorage.getItem("currentCity")).currentCityName;
      this.cityId = JSON.parse(localStorage.getItem("currentCity")).currentCityId
    }
    let screenData1 = JSON.parse(localStorage.getItem("screen"));
    if (screenData1) {
      localStorage.removeItem("screenRank");
      this.searchName = screenData1.searchName?screenData1.searchName:screenData1.name;
      this.standType = screenData1.standType;
      this.searchType = screenData1.searchType;
      this.lineType = screenData1.lineType;
      if (this.searchType == "line") {
        this.subwayLineId = screenData1.subwayLineId;
        if (this.standType != 'stand9999') {
          this.subwaySiteId = screenData1.value;
        }
        this.getLineList();
        this.getStandingList(this.subwayLineId);
      } else {
        this.districtId = screenData1.districtId;
        if (this.standType != 'stand9999') {
          this.zoneId = screenData1.value;
        }
        this.getAreaList();
        this.getCircleList(this.districtId);
      }
      this.getBuessinessList();
    }
    if (this._uid == 2) {
      localStorage.removeItem("screenRank");
    }
    this.isMiniProgram(res => {
      if (res) {
        this.getBuessinessList();
      } else {
        let screenData = JSON.parse(localStorage.getItem("screenRank"));
        if (screenData) {
          this.standType = screenData.type.standType;
          this.searchType = screenData.type.searchType;
          this.lineType = screenData.type.lineType;
          this.searchName = screenData.type.searchName;
          if (this.searchType == "line") {
            this.getLineList();
            this.getStandingList(screenData.data.subwayLineId);
          } else {
            this.getAreaList();
            this.getCircleList(screenData.data.districtId);
          }
          this.getBuessinessList(false, screenData.data);
        } else {
          this.getBuessinessList();
        }
      }
    });
    this.getAreaList();
  },
  mounted() {
    if (timerInt) {
      clearInterval(timerInt)
    }
    var timerInt = setInterval(() => {
      let contrastCount = JSON.parse(localStorage.getItem('cellContrastArr'));
      if (contrastCount) {
        this.contrastCount = contrastCount.length
        this.contrastArr = contrastCount;
      }
    }, 300);
  },
  methods: {
    goSearch() {
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url: "/pages/search/index?cityId=" + this.cityId
          });
        } else {
          this.$router.push({
            path: "/search",
            query: { cityId: this.cityId }
          });
        }
      });
    },
    goCitySelect() {
      let currentCity = JSON.parse(localStorage.getItem("currentCity"));
      let selectCityIndex = JSON.parse(localStorage.getItem("selectCityIndex"));
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:
              "/pages/select_city/index?currentCityName=" +
              currentCity.currentCityName +
              "&selectCityIndex=" +
              selectCityIndex
          });
        } else {
          this.$router.push({
            path: "/select_city",
            query: {
              currentCityName: currentCity.currentCityName,
              selectCityIndex: selectCityIndex
            }
          });
        }
      });
    },
    // 位置、地铁切换
    selectArea(info) {
      this.searchType = info;
      this.searchName = "";
      this.standType = "";
      this.lineType = "";
      this.standingList = [];
      if (info == "area") {
        this.subwayLineId = "";
        this.subwaySiteId = "";
        this.getAreaList();
      } else {
        this.districtId = "";
        this.zoneId = "";
        this.getLineList();
      }
    },
    // 选择排序
    selectSorting() {
      if (this.isSelect||this.isSelect1) {
        return false
      }
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "排序方式"
      });
      this.isSelect2 = !this.isSelect2;
      this.selectSort = !this.selectSort;
    },
    checkedSort(index,type) {
      if (type=='more') {
        let userId = localStorage.getItem('userId');
        if (!userId||userId=='undefined') {
          Toast('请登录后查看');
          this.isMiniProgram(res => {
            if (res) {
              wx.miniProgram.redirectTo({
                url: "/pages/login/index?from=area_list&cityId="+this.cityId
              });
            } else {
            
            }
          });
        }else{
          this.userId = userId;
          for (let i = 0; i < this.moreList.length; i++) {
            this.moreList[i].checked = false;
          }
          this.moreList[index].checked = !this.moreList[index].checked;
          this.isSelect1 = false;
          this.searchName1 = this.moreList[index].label;       
          this.selectSort1 = false;
          this.moreTab = index==0?1:2;
        }
      }else{
        this.pageNum = 1;
        for (let i = 0; i < this.sortingList.length; i++) {
          this.sortingList[i].checked = false;
        }
        this.sortingList[index].checked = !this.sortingList[index].checked;
        this.isSelect2 = false;
        this.searchName2 = this.sortingList[index].label;
        this.sortItem = index == 0||index == 1?1:2;
        this.sorting = index == 0||index == 2 ? "DESC" : "ASC";
        this.selectSort = false;
      }
      this.getBuessinessList();
    },
    //返回地图页
    returnMap(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "地图模式"
      });
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:"/pages/home/index"
          });
        } else {
          this.$router.push({
            path: "/"
          });
        }
      });
    },
    //打开更多
    openMore(){
      if (this.isSelect||this.isSelect2) {
        return false
      }
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "更多"
      });
      this.isSelect1 = !this.isSelect1;
      this.selectSort1 = !this.selectSort1;
    },
    // 选择区域
    chooseArea() {
      if (this.isSelect2||this.isSelect1) {
        return false
      }
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "区域筛选"
      });
      this.selectSort = false;
      this.isSelect = !this.isSelect;
    },
    // 地铁线对应的站
    selectStanding(name, index, info) {
      this.standType = "";
      this.firstInfo = info;
      this.lineType = "line" + index;
      this.areaIndex = index;
      if (name == "line") {
        this.isSelect = false;
        this.searchName = "";
        this.districtId = "";
        this.subwayLineId = "";
        this.subwaySiteId = "";
        this.zoneId = "";
        this.pageNum = 1;
        this.getBuessinessList();
      } else {
        if (this.searchType == "area") {
          this.districtId = info.value;
          this.getCircleList(info.value);
        } else {
          this.subwayLineId = info.value;
          this.getStandingList(info.value);
        }
        this.searchName = info.name;
      }
    },
    selectDistrict(name, index, item) {
      let model = {};
      if (index != "9999") {
        model = item;
        if (this.searchType == "area") {
          this.zoneId = item.value;
        } else {
          this.subwaySiteId = item.value;
        }
        this.searchName = item.name;
      } else {
        model = this.allInfo;
        this.subwaySiteId = "";
        this.zoneId = "";
        this.searchName = this.firstInfo.name;
      }
      model.cityId = this.cityId;
      this.standType = "stand" + index;
      this.isSelect = false;
      this.pageNum = 1;
      let data = {
        cityId: this.cityId, // 城市ID
        districtId: this.districtId, // 区域ID
        zoneId: this.zoneId, // 	商圈ID
        subwayLineId: this.subwayLineId, // 地铁线路ID
        subwaySiteId: this.subwaySiteId, // 地铁站点ID
        sorting: this.sorting, // 排序
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      let type = {
        standType: this.standType,
        lineType: this.lineType,
        searchType: this.searchType,
        searchName: this.searchName
      };
      model.standType = this.standType;
      model.lineType = this.lineType;
      model.searchType = this.searchType;
      model.searchName = this.searchName;
      model.districtId = this.districtId;
      model.zoneId = this.zoneId;
      model.subwayLineId = this.subwayLineId;
      model.subwaySiteId = this.subwaySiteId;
      model.isCell = true;
      localStorage.setItem('screen',JSON.stringify(model))
      this.isMiniProgram(res => {
        if (!res) {
          localStorage.setItem(
            "screenRank",
            JSON.stringify({
              data: data,
              type: type
            })
          );
        }
      });
      this.getBuessinessList();
      this.searchIndex = index;
    },
    hideSearch() {
      this.isSelect = false;
    },
    hideMore(){
      this.selectSort = false;
      this.isSelect2 = false;
    },
    hideSort(){
      this.selectSort1 = false;
      this.isSelect1 = false;
    },
    //+关注
    plusAttention(index,item){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "+关注"
      });
      if (item.isCare==1) {
        return false;
      }
      let userId = localStorage.getItem('userId');
      if (!userId||userId=='undefined') {
        Toast('请登录后查看');
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.redirectTo({
              url: "/pages/login/index?from=cell_list&cityId="+this.cityId
            });
          } else {
          
          }
        });
      }else{
        this.attentionArr.push(index);
        this.$axios
          .post("api/xz/care/save/", {
            cityId:this.cityId,
            id:item.communityId,
            type:2,
            userId:userId
          })
          .then(res => {
            if (res.success) {
              Toast('关注成功！')
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //+对比
    plusContrast(index,item){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "+对比"
      });
        if (this.contrastCount>2) {
            Dialog.confirm({
                title: '添加新小区',
                message: '继续添加小区将覆盖掉最先加入对比的小区，是否确定添加新小区？'
            }).then(() => {
                // on confirm
                this.contrastArr.push(Number(item.communityId));
                this.contrastArr.shift();
                //存储对比信息
                localStorage.setItem('cellContrastArr',JSON.stringify(this.contrastArr))
            }).catch(() => {
                // on cancel
            });
        }else{
            this.contrastArr.push(Number(item.communityId));
            this.contrastCount++;
            if (this.contrastCount==3) {
              Toast('已加满3个小区，快去对比吧');
              localStorage.setItem('cellContrastArr',JSON.stringify(this.contrastArr))
            }else{
              localStorage.setItem('cellContrastArr',JSON.stringify(this.contrastArr));
            }
        }
    },
    goContrast(){
      this.addBuried({
        source: "1",
        eventType: "点击事件",
        eventContent: "进入对比页"
      });
      if (this.contrastCount<2) {
        Toast('只有添加2个及以上小区时才能进入对比页面');        
        return false;
      }
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:"/pages/village_contrast/index" 
          });
        } else {
          this.$router.push({
            path: "/village_contrast"
          });
        }
      });
    },
    goDetail(e) {
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateTo({
            url:
              "/pages/cell_detail/index?zoneId=" +
              e.communityId +
              "&latitude=" +
              e.latitude +
              "&longitude=" +
              e.longitude +
              "&cityId=" +
              this.cityId
          });
        } else {
          this.$router.push({
            path: "/cell_detail",
            query: {
              cityId: this.cityId,
              zoneId: e.communityId,
              latitude: e.latitude,
              longitude: e.longitude
            }
          });
        }
      });
    },
    // 获取区域数据
    getAreaList() {
      this.$axios
        .post("api/xz/area/list/", {
          cityId: this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.districtList = list;
            this.allInfo = list[0];
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取区域下面对应的商圈
    getCircleList(areaId) {
      this.$axios
        .post("api/xz/zone/infolist/", {
          areaId: areaId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.standingList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取地铁线
    getLineList(loadMore) {
      this.$axios
        .post("api/xz/subwayline/list/", {
          cityId: this.cityId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.districtList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    // 获取地铁线对应的地铁站
    getStandingList(lineId) {
      this.$axios
        .post("api/xz/subwaysite/list/", {
          lineId: lineId
        })
        .then(res => {
          if (res.success) {
            let list = res.result;
            this.standingList = list;
          } else {
          }
        })
        .catch(err => {});
    },
    onLoad() {
      this.getBuessinessList(true);
    },
    onRefresh() {
      this.pageNum = 1;
      this.getBuessinessList();
    },
    // 获取商圈排名
    getBuessinessList(loadMore, screenData) {
      let { pageNum, pageSize } = this;
      pageNum = loadMore ? pageNum + 1 : pageNum;
      let data = {
        cityId: this.cityId, // 城市ID
        districtId: this.districtId, // 区域ID
        zoneId: this.zoneId, // 	商圈ID
        subwayLineId: this.subwayLineId, // 地铁线路ID
        subwaySiteId: this.subwaySiteId, // 地铁站点ID
        sorting: this.sorting, // 排序
        tab:this.moreTab,
        sortItem:this.sortItem,
        pageNum,
        pageSize,
        userId:this.userId
      };
      this.$axios
        .post("api/xz/community/list/", screenData ? screenData : data)
        .then(res => {
          if (res.success) {
            let list = res.result,
              len = list.length;
            this.villageList = loadMore ? this.villageList.concat(list) : list;
            for (let i = 0; i < this.villageList.length; i++) {
              if (
                this.villageList[i].ratio &&
                typeof this.villageList[i].ratio == "number"
              ) {
                this.villageList[i].ratio =
                  Math.abs(
                    parseInt(this.villageList[i].ratio * 100 * 100) / 100
                  ) + "%";
              }
            }
            if (len < pageSize) {
              // this.allLoaded = true;
              this.finished = true;
            }else{
              this.finished = false;
            }
            this.pageNum = pageNum;
          } else {
            this.error = true;
            this.villageList=[];
            Toast(res.status.description);
          }
          this.loading = false;
          let timer;
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(()=>{
            this.isRefresh = false;
          },300)
        })
        .catch(err => {});
    }
  },
  destroyed() {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '小区列表停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>
<style lang="less">
.rank-container {
  width: 750px;
  min-height: 100vh;
  background: #f7f7f7;
  .van-hairline--surround::after{
    border: none;
  }
  .filter-mask {
    position: fixed;
    top: 0;
    width: 100%;
    bottom: 0;
    background: rgba(0, 0, 0, 0.32);
    z-index: 1;
  }
  .top-search {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 16px;
    height: 72px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background: #fff;
    .input-navigate-box {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 32px;
    }
    .img-search {
      height: 72px;
      margin-left: 24px;
      font-size: 28px;
      color: #a8a8a8;
      line-height: 74px;
      flex: 1;
      background-repeat: no-repeat;
      background-position: 18px center;
      background-size: 32px;
      background-color: #f3f7fb;
      border-radius: 16px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .search-icon {
      height: 32px;
      width: 32px;
      margin-left: 24px;
      margin-right: 18px;
    }
    .HomeSearchBar{
        height:32px;
        font-size:28px;
        color:rgba(189,195,206,1);
        line-height:32px;
    }
    .location-img {
      margin-right: 8px;
      margin-left: 8px;
      width: 22px;
      height: 30px;
    }
    .city-arrow {
      margin-left: 14px;
      width: 14px;
      height: 8px;
    }
  }
  .select-container {
    position: fixed;
    top: 104px;
    z-index: 99;
    width: 100%;
    height: 88px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .area-box {
      flex: 3;
      text-align: center;
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      .area-title {
        font-size: 30px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(35, 44, 55, 1);
      }
      .selected {
        color: #4169e1;
        border: none;
      }
      .area-img {
        width: 12px;
        height: 8px;
        margin-left: 14px;
      }
    }
    .order-box {
      width: 182px;
      text-align: center;
      border-left: 4px solid #efefef;
      .order-img {
        width: 36px;
        height: 36px;
      }
    }
  }
  .filter-warp {
    position: absolute;
    top: 88px;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    .filter-container {
      max-height: 828px;
      overflow-y: scroll;
      background: #f3f7fb;
      font-family: PingFangSC-Regular;
      font-size: 30px;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      line-height: 42px;
      border-top: 2px solid #eee;
      .city-box {
        display: flex;
        display: -webkit-flex;
        height: 100%;
        .filter-area {
          height: 828px;
          width: 33%;
          overflow-y: scroll;
          text-align: left;
          background: #ffffff;
          padding-left: 20px;
        }
        .city {
          overflow-y: scroll;
          text-align: center;
        }
        .district {
          padding: 0 20px;
        }
        .selected {
          color: #4169e1;
          border: none;
        }
      }
      .city-list {
        background: rgba(247, 247, 247, 1);
      }
      .filter-city {
        width: 183px;
        overflow-y: scroll;
      }
      .filter-district {
        height: 828px;
        flex: 1;
        overflow-y: scroll;
        text-align: left;
        background: #ffffff;
      }
    }
    .city-box .city,
    .city-box .district,
    .city-box .area {
      height: 104px;
      line-height: 104px;
      color: #232c37;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      .select-img {
        width: 28px;
        height: 20px;
      }
    }
    .selected {
      background: #fff;
      border: none;
    }
  }

  .selected {
    color: #4169e1;
    border: none;
  }
  .van-pull-refresh__track {
    min-height: 90vh;
  }
  .village-content-wrapper {
    background: #f7f7f7;
    width: 718px;
    height: 100%;
    margin-top: 192px;
    padding: 16px;
    .village-content {
      background: #fff;
      padding: 24px 24px 14px;
      margin-bottom: 18px;
      position: relative;
      .rankimg-box {
        position: absolute;
        right: 18px;
        top: -8px;
        .rank-img {
          width: 78px;
          height: 38px;
        }
      }
      .content-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .content-header-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .grade-box {
            width: 110px;
            height: 36px;
            background: rgba(245, 103, 11, 1);
            border-radius: 6px;
            box-sizing: border-box;
            line-height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            .header-img {
              margin: 0px 6px 0 10px;
              width: 16px;
              height: 24px;
            }
            .grade-num {
              font-size: 28px;
              font-weight: 600;
              color: rgba(255, 255, 255, 1);
            }
          }
          .title {
            font-size: 32px;
            font-weight: 600;
            color: rgba(35, 44, 55, 1);
            margin-right: 10px;
          }
        }
      }
      .content-info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 38px 0 24px;
        .info-img {
          width: 24px;
          height: 26px;
        }
        .rank-item {
          text-align: center;
          .rank-title {
            font-size: 26px;
            font-weight: 400;
            color: rgba(137, 147, 159, 1);
            line-height: 36px;
            margin-bottom: 16px;
          }
          .rank-number {
            font-size: 32px;
            font-weight: 400;
            color: rgba(35, 44, 55, 1);
            line-height: 44px;
          }
        }
      }
      .operation-box{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0 0;
          border-top: 2px solid #EFEFEF;
          .business-circle{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height:36px;
            line-height:36px;
            .business-circle-img{
              width: 24px;
              height: 28px;
            }
            .business-circle-dec{
              font-size:26px;
              color:rgba(137,147,159,1);
              margin-left: 8px;
            }
          }
          .operation{
              .operation-btn{
                background: #fff;
                width:96px;
                height:40px;
                line-height: 40px;
                font-size:22px;
                border-radius:4px;
                padding: 0;
              }
              .finished{
                color: #BDC3CE;
                border: 2px solid #BDC3CE;
                margin-left: 14px;
              }
              .contrast{
                color: #4169E1;
                border: 2px solid #4169E1;
              }
              .attention{
                color: #F5670B;
                border: 2px solid #F5670B;
                margin-left: 14px;
              }
          }
      }
    }
  }
  .sorting-box {
    width: 100%;
    position: absolute;
    top: 192px;
    left: 0;
    z-index: 2;
    background: #fff;
    width: 100%;
    border-top: 2px solid #efefef;
    .sort-item {
      padding: 32px 30px 24px;
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(35, 44, 55, 1);
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .blue-color {
        color: #4169e1;
      }
    }
    .sort-img {
      width: 20px;
      height: 20px;
      float: right;
    }
  }
  .footer {
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #f7f7f7;
    padding-bottom: 34px;
    color: rgba(189, 195, 206, 1);
    font-size: 26px;
  }
}
.over-hidden {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  z-index: 0;
}
.nodata {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  margin-top: 212px;
//   padding-top: 16px;
  text-align: center;
  .info {
    font-size: 28px;
    color: #6f7884;
    line-height: 88px;
    display: block;
    background: #fff;
  }
}
.contrast-box{
    position: fixed;
    right: 16px;
    bottom: 130px;
    width:84px;
    height:84px;
    background:rgba(35,44,55,1);
    box-shadow:0px 4px 10px 0px rgba(35,44,55,0.3);
    border-radius:6px;
    opacity:0.8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .contrast-img{
        width: 40px;
        height: 40px;
    }
    .contrast-dec{
        font-size:24px;
        color:rgba(255,255,255,1);
    }
    .contrast-marker-box{
        position: absolute;
        left: -10px;
        top: -10px;
        width:32px;
        height:32px;
        line-height: 32px;
        text-align: center;
        border-radius: 32px;
        background:rgb(65,105,225);
        border:2px solid rgba(247,247,247,1);
        .contrast-marker{
            font-size: 24px;
            color: #fff;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/cell_list/index.vue